import React, { useEffect } from 'react'
import { useState } from 'react'
import { Switch } from '@headlessui/react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const Toggle = ({ onChange, value }) => {
    const [enabled, setEnabled] = useState(false)

    useEffect(() => {
        setEnabled(value)
    }, [value])

    return (
        <div className="w-full h-auto flex items-center justify-start my-4 md:my-6">
            <Switch
                checked={enabled}
                onChange={val => {
                    setEnabled(val)
                    onChange(val)
                }}
                className={clsx(
                    enabled ? 'bg-yellow' : 'bg-grayLines',
                    'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-offset-2',
                )}
            >
                <span className="sr-only"></span>
                <span
                    aria-hidden="true"
                    className={clsx(
                        enabled ? 'translate-x-2.5' : '-translate-x-2.5',
                        'pointer-events-none inline-block h-5 w-5 min-w-5 min-h-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
                    )}
                />
            </Switch>
            <p className="text-black70 font-semibold text-sm ml-2">
                Show Deals
            </p>
        </div>
    )
}

Toggle.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.bool,
}

export default Toggle
